import InviteFriend from './InviteFriend';

export default InviteFriend;
